import { z } from 'zod';
/**
 * Largest page the offset-paged list endpoints serve.
 *
 * One bound for all of them, because the point is to have a bound at all: a list endpoint that
 * accepts any `limit` lets a single request read an entire table. It sits above the 500 rows a
 * staff table can ask for, so it rejects only requests nothing sends today.
 *
 * The cursor-paged endpoints state their own, much lower, maximum; they were designed with one.
 */
export const FLOW_API_MAX_PAGE_LIMIT = 1_000;
/** How many records one page of an offset-paged list endpoint returns. */
export const FlowApiPageLimitSchema = z.coerce
    .number()
    .int()
    .positive()
    .max(FLOW_API_MAX_PAGE_LIMIT);
/** How many matches an offset-paged list endpoint skips before the page it returns. */
export const FlowApiPageOffsetSchema = z.coerce.number().int().nonnegative();
//# sourceMappingURL=pageLimit.js.map